import { ThailandDestinationKey } from '../../destinations/thailand/thailand-destinations-card-map';
import { ThailandArticleKey } from './thailand-articles-card-map';

export const relatedArticlesSlugsMap: Record<
  ThailandArticleKey,
  (ThailandDestinationKey | ThailandArticleKey)[]
> = {
  'general-thailand': [
    'bangkok',
    'phuket',
    'koh-samui',
    'chiang-mai',
    'pattaya',
    'thailand-tax-refund',
    'bangkok-markets',
    'bangkok-malls',
  ],
  'bangkok-malls': [
    'bangkok',
    'bangkok-transportation',
    'bangkok-markets',
    'khaosan-road',
    'floating-market',
    'train-night-market',
    'thailand-tax-refund',
    'general-thailand',
  ],
  'thailand-tax-refund': [
    'bangkok',
    'phuket',
    'koh-samui',
    'chiang-mai',
    'pattaya',
    'general-thailand',
  ],
  'bangkok-markets': [
    'thailand-tax-refund',
    'general-thailand',
    'bangkok',
    'bangkok-transportation',
    'ko-kret',
    'bangkachao',
    'lumphini-park',
    'benchakitti-park',
    'wat-saket',
    'kanchanaburi',
    'bangkok-malls',
    'khaosan-road',
  ],
  'bangkok-transportation': [
    'thailand-tax-refund',
    'general-thailand',
    'bangkok',
    'bangkok-markets',
    'ko-kret',
    'bangkachao',
    'lumphini-park',
    'benchakitti-park',
    'wat-saket',
    'kanchanaburi',
    'bangkok-malls',
    'khaosan-road',
  ],
  'chiang-mai-markets': [
    'thailand-tax-refund',
    'general-thailand',
    'chiang-mai',
    'pai',
    'chiang-rai',
    'doi-inthanon',
    'khlong-mae-kha',
    'chiang-rai-to-golden-triangle',
    'chiang-mai-attractions',
    'chiang-rai-to-chiang-mai',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
  ],

  'khaosan-road': [
    'thailand-tax-refund',
    'general-thailand',
    'bangkok',
    'bangkok-transportation',
    'bangkok-markets',
    'ko-kret',
    'bangkachao',
    'lumphini-park',
    'benchakitti-park',
    'wat-saket',
    'kanchanaburi',
    'bangkok-malls',
  ],
  'floating-market': ['thailand-tax-refund', 'general-thailand'],
  'chiang-mai-attractions': [
    'thailand-tax-refund',
    'general-thailand',
    'chiang-mai',
    'pai',
    'chiang-rai',
    'doi-inthanon',
    'khlong-mae-kha',
    'chiang-rai-to-golden-triangle',
    'chiang-mai-markets',
    'chiang-rai-to-chiang-mai',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
  ],
  'chiang-mai-pai-chiang-rai-road-attractions': [
    'thailand-tax-refund',
    'general-thailand',
    'chiang-mai',
    'pai',
    'chiang-rai',
    'doi-inthanon',
    'khlong-mae-kha',
    'chiang-rai-to-golden-triangle',
    'chiang-mai-attractions',
    'chiang-mai-markets',
    'chiang-rai-to-chiang-mai',
    'thailand-myanmar-border-trip',
  ],
  'thailand-myanmar-border-trip': [
    'thailand-tax-refund',
    'general-thailand',
    'chiang-mai',
    'pai',
    'chiang-rai',
    'doi-inthanon',
    'khlong-mae-kha',
    'chiang-rai-to-golden-triangle',
    'chiang-mai-attractions',
    'chiang-mai-markets',
    'chiang-rai-to-chiang-mai',
    'chiang-mai-pai-chiang-rai-road-attractions',
  ],
  'chiang-rai-to-golden-triangle': [
    'thailand-tax-refund',
    'general-thailand',
    'chiang-mai',
    'pai',
    'chiang-rai',
    'doi-inthanon',
    'khlong-mae-kha',
    'chiang-mai-attractions',
    'chiang-mai-markets',
    'chiang-rai-to-chiang-mai',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
  ],
  'chiang-rai-to-chiang-mai': [
    'thailand-tax-refund',
    'general-thailand',
    'chiang-mai',
    'pai',
    'chiang-rai',
    'doi-inthanon',
    'khlong-mae-kha',
    'chiang-rai-to-golden-triangle',
    'chiang-mai-attractions',
    'chiang-mai-markets',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
  ],
  'train-night-market': ['thailand-tax-refund', 'general-thailand'],
  'phuket-family-hotels': [
    'phuket',
    'khao-lak',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'hua-hin-attractions': ['bangkok', 'general-thailand', 'thailand-tax-refund'],
};
